module.exports = __webpack_public_path__ + "static/island-fencing-academy-a9ff934a03596f64826ebc3bf5b950d8.png";